import { render, staticRenderFns } from "./city-edit.vue?vue&type=template&id=bdc67668&scoped=true&"
import script from "./city-edit.vue?vue&type=script&lang=js&"
export * from "./city-edit.vue?vue&type=script&lang=js&"
import style0 from "./city-edit.vue?vue&type=style&index=0&id=bdc67668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc67668",
  null
  
)

export default component.exports